function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { pathOr } from 'ramda';
import { i18n } from 'invision-core';
import LocaleKeys from '../../../locales/keys';
var RedemptionCodeDetailsGeneralController = /*#__PURE__*/function () {
  function RedemptionCodeDetailsGeneralController($timeout) {
    _classCallCheck(this, RedemptionCodeDetailsGeneralController);
    this.$timeout = $timeout;
    this.customerCareLocaleKeys = LocaleKeys;
    this.couponStatusTypes = {
      //inventory status : api value
      1: '1',
      //active,
      2: '2',
      //removed
      3: '4',
      //pending,
      4: '3' //suspended
    };
    this.discountTypes = {
      1: i18n.translate(this.customerCareLocaleKeys.COUPONS.REDEMPTION_CODE_DETAILS.LABELS.DISCOUNT_TYPES.PERCENTAGE_OFF),
      3: i18n.translate(this.customerCareLocaleKeys.COUPONS.REDEMPTION_CODE_DETAILS.LABELS.DISCOUNT_TYPES.AMOUNT_OFF)
    };
    this.showModifyExpirationDateModal = false;
  }
  return _createClass(RedemptionCodeDetailsGeneralController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.modifyExpirationDateDialogConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.modifyExpirationDateDialogApi = event.api;
        }
      };
    }
  }, {
    key: "openModifyExpirationDateModal",
    value: function openModifyExpirationDateModal() {
      this.showModifyExpirationDateModal = true;
      this.$timeout(this.modifyExpirationDateDialogApi.open);
    }
  }, {
    key: "closeModifyExpirationDateModal",
    value: function closeModifyExpirationDateModal() {
      this.showModifyExpirationDateModal = false;
      this.modifyExpirationDateDialogApi.close();
    }
  }, {
    key: "expirationDateSubmitted",
    value: function expirationDateSubmitted(date) {
      this.updateExpirationDate()(date);
      this.closeModifyExpirationDateModal();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (changesObj.redemptionDetails) {
        var couponStatusType = pathOr('', ['Coupon', 'Status'], changesObj.redemptionDetails.currentValue);
        this.couponStatusLabel = this.couponStatusTypes[couponStatusType];
        var discountType = pathOr('', ['Discount', 'Type'], changesObj.redemptionDetails.currentValue);
        this.discountTypeLabel = this.discountTypes[discountType];
        this.isPercentDiscount = discountType === 1;
        this.percentDiscountAmount = "".concat(changesObj.redemptionDetails.currentValue.Discount.Amount * 100, '%');
        this.isRedeemable = changesObj.redemptionDetails.currentValue.RedemptionCode.IsRedeemable ? i18n.translate(this.customerCareLocaleKeys.YES) : i18n.translate(this.customerCareLocaleKeys.NO);
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.closeModifyExpirationDateModal();
    }
  }]);
}();
export default {
  bindings: {
    isGlobal: '<',
    redemptionDetails: '<',
    updateExpirationDate: '&'
  },
  template: require('./redemption.code.details.general.html'),
  controller: RedemptionCodeDetailsGeneralController
};